/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Script } from './Script.js';
import {
    ScriptFromJSON,
    ScriptFromJSONTyped,
    ScriptToJSON,
} from './Script.js';

/**
 * 
 * @export
 * @interface ScriptResponse
 */
export interface ScriptResponse {
    /**
     * 
     * @type {Script}
     * @memberof ScriptResponse
     */
    data?: Script;
    /**
     * 
     * @type {number}
     * @memberof ScriptResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptResponse interface.
 */
export function instanceOfScriptResponse(value: object): boolean {
    return true;
}

export function ScriptResponseFromJSON(json: any): ScriptResponse {
    return ScriptResponseFromJSONTyped(json, false);
}

export function ScriptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScriptFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptResponseToJSON(value?: ScriptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScriptToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

